import { Module } from '@nestjs/common';
import { AuditModule } from 'src/audit/audit.module';
import { OrdenesCompraModule } from 'src/ordenes-compra/ordenes-compra.module';
import { PrismaModule } from 'src/prisma/prisma.module';
import { RecepcionesCompraController } from './recepciones-compra.controller';
import { RecepcionesCompraService } from './recepciones-compra.service';

@Module({
  imports: [PrismaModule, OrdenesCompraModule, AuditModule],
  controllers: [RecepcionesCompraController],
  providers: [RecepcionesCompraService],
  exports: [RecepcionesCompraService],
})
export class RecepcionesCompraModule {}
